import { Test } from "./Test";


export class GaitTest extends Test {
    measures: Measures;
}

class GaitScore {
    fall_risk: Number;
    gait_speed: Number;
    distance: Number;
    ambulation_time: Number;
    velocity: Number;
    mean_normlized_velocity: Number;
    number_of_steps: Number;
    cadence: Number;
    left: Lengths;
    right: Lengths;

}
class Measures {
    score: GaitScore;
    used_assistive_device: Boolean;
}
class Lengths {
    step_length: Number;
}

export function GetGaitFallRisk(gaitSpeed: number) {
    const normalGaitSpeed = 92.8;
    // The study found specifically that a 10 cm/s decrease in gait speed
    // was associated with a 1.069 risk ratio of a fall.
    const riskNum = 1.069;

    // I couldn't figure out an accurate way to show these confidence intervals
    //var confidenceMin = 1.001; commented because never used. this commented code shouldn't be removed
    //var confidenceMax = 1.142;
    const riskDen = 10;
    const normalRisk = 44.0;

    var power = (normalGaitSpeed - gaitSpeed) / riskDen;
    var riskRatio = Math.pow(riskNum, power);

    // The study found that 46% of falls were injurous
    // However, they couldn't predict injury rate from gait speed, (p-value 0.249)
    // so I let it be fixed at 46%.
    //var injurousFallRate = 0.46;

    // return new GaitFallRisk
    // {
    //     riskRatio = riskRatio,
    //     absoluteRisk = Math.Min(100.0, normalRisk * riskRatio),
    //     absoluteInjurousRisk = Math.Min(100.0, normalRisk * riskRatio * injurousFallRate),
    // };

    return Math.min(100.0, normalRisk * riskRatio);
}



// const dummyJson =
// {
//     "test_type": "gailt",
//     "score": {
//         "fall_risk": 65,
//         "gait_speed": 1.03,
//         "distance": 3.1,
//         "ambulation_time": 1200,
//         "velocity": 139.38,
//         "mean_normlized_velocity": 175.18,
//         "number_of_steps": 6,
//         "cadence": 130,
//         "left": {
//             "step_length": 0.4004
//         },
//         "right": {
//             "step_length": 0.569
//         },
//     },
//     "used_assistive_device": "False",
//     "start_time": "16738499806",
//     "end_time": "1673850008",
// }


// structure used in Balance Desktop and Portal
// const dummyJson =
// {
//     "test_type": "gailt",
//     "measures": {
//         "score": {
//             "fall_risk": 65,
//             "gait_speed": 1.03,
//             "distance": 3.1,
//             "ambulation_time": 1200,
//             "velocity": 139.38,
//             "mean_normlized_velocity": 175.18,
//             "number_of_steps": 6,
//             "cadence": 130,
//             "left": {
//                 "step_length": 0.4004
//             },
//             "right": {
//                 "step_length": 0.569
//             },
//         },
//         "used_assistive_device": "False",
//     },
//     "start_time": "16738499806",
//     "end_time": "1673850008",
// }